import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';
import { Button, Spinner, Alert } from 'reactstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { UserContext } from '../../contexts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function CardSender(props) {
    const firebase = useFirebase();
    const user = useContext(UserContext);
    const card = props.card;
    const [tradeUrl, setTradeUrl] = useState();
    const [loadingTradeUrl, setLoadingTradeUrl] = useState(false);

    async function getTradeUrl() {
        setLoadingTradeUrl(true);
        console.log({senderId:user.id, cardId:card.id});
        var createTradeUrl = firebase.app().functions('asia-northeast1').httpsCallable('createTradeUrl');
        var ret = await createTradeUrl({senderId:user.id, cardId:card.id});
        var url = window.location.protocol + "//" + window.location.host + "/trade?id=" + ret.data.message;
        setTradeUrl(url);
        setLoadingTradeUrl(false);
    }

    let buttons;
    if(tradeUrl) {
        buttons = (
            <React.Fragment>
                <Alert color="warning">送ったURLは相手が受け取ると使えなくなります。一人ずつ「このカードを送る」から新しいURLを作って送ってください。</Alert>
                <div className="mb-2">
                    <Button color="success" onClick={() => window.location.href = ("https://line.me/R/msg/text/?" + encodeURI("マッチングカードダスを受け取ってください！ " + tradeUrl))}><FontAwesomeIcon icon={["fab", "line"]}/>{' '}LINEで送る</Button>
                    {' '}
                    <CopyToClipboard text={tradeUrl}>
                        <Button color="secondary"><FontAwesomeIcon icon="copy"/>{' '}URLをコピー</Button>
                    </CopyToClipboard>
                </div>                
            </React.Fragment>
        );
    } else {
        buttons = (
            <Button color="primary" onClick={async () => await getTradeUrl()} disabled={loadingTradeUrl}>
                {!loadingTradeUrl
                ?<FontAwesomeIcon icon="link"/>
                :<Spinner size="sm" />}
                {' '}このカードを送る
            </Button>
        );
    }

    return (
        <React.Fragment>
            {buttons}
        </React.Fragment>
    );
}